/**
 * Institution-theme registry — Phase 4 multi-institution UI theming.
 *
 * Lookup by institution slug. UMD is the default fallback when an
 * unknown slug arrives (defensive: keeps the UI rendering rather
 * than crashing on an unseeded institution).
 */
import type { InstitutionTheme } from './types';
import { umdTheme } from './umd';
import { sjsuTheme } from './sjsu';
import { ucmercedTheme } from './ucmerced';
import { sdsuTheme } from './sdsu';
import { deanzaTheme } from './deanza';
import { mercedCollegeTheme } from './merced-college';
import { foothillTheme } from './foothill';
import { montgomeryCollegeTheme } from './montgomery-college';
import { unicTheme } from './unic';
import { evcTheme } from './evc';
import { sjccTheme } from './sjcc';
import { missionCollegeTheme } from './mission-college';
import { csueastbayTheme } from './csueastbay';
import { ucberkeleyTheme } from './ucberkeley';
import { ucdavisTheme } from './ucdavis';

export const themes: Record<string, InstitutionTheme> = {
  umd: umdTheme,
  sjsu: sjsuTheme,
  ucmerced: ucmercedTheme,
  sdsu: sdsuTheme,
  deanza: deanzaTheme,
  'merced-college': mercedCollegeTheme,
  foothill: foothillTheme,
  'montgomery-college': montgomeryCollegeTheme,
  unic: unicTheme,
  evc: evcTheme,
  sjcc: sjccTheme,
  'mission-college': missionCollegeTheme,
  csueastbay: csueastbayTheme,   // W56 Worker A keyed row
  ucberkeley: ucberkeleyTheme,
  ucdavis: ucdavisTheme,
};

export const defaultTheme: InstitutionTheme = umdTheme;

export const resolveTheme = (slug: string | undefined): InstitutionTheme => {
  if (!slug) return defaultTheme;
  return themes[slug] ?? defaultTheme;
};

export type { InstitutionTheme, ThemeColors, RgbTriplet } from './types';
